
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components"
import { setAnimationControlRoute } from "../../../../features/topPagesMap/topPagesMapSlice";

const Container = styled.div`
    position: relative;
    width: 300px;
    height: 4px;
    background-color: ${({theme}) => theme.mainTextColor};
    cursor: pointer;
    margin: 30px auto;
    border-radius: 5px;

    .dot{
        position: absolute;
        top: -6px;
        left: ${({position}) => `${position}%`};
        width: 16px;
        height: 16px;
        background-color: var(--color-main);
        border-radius: 50%;
        cursor: pointer;
        transform: translateX(-50%);
    }
`

const LineRouteSliderInput = () => {

  const dispatch = useDispatch()

  const {animationControlRoute} = useSelector(state => state.topPagesMap)

    const [isDragging, setIsDragging] = useState(false); // Sürükleme durumunu izler
    const sliderRef = useRef(null); // Slider referansı
  
    // Sürükleme işlemini başlat ve konumu güncelle
    const handleMouseDown = (e) => {
      e.preventDefault(); // Varsayılan davranışı engelle (örneğin, metin seçimi)
      setIsDragging(true); // Sürükleme işlemini başlat
  
      const slider = sliderRef.current;
      const sliderRect = slider.getBoundingClientRect();
      const offsetX = e.clientX - sliderRect.left; // Fare pozisyonu - slider'ın sol kenarı
      let newPosition = (offsetX / sliderRect.width) * 100; // Yüzdelik konumu hesapla
  
      // Minimum değeri 1 olarak ayarla ve maksimum değeri 100 ile sınırla
      newPosition = Math.max(1, Math.min(newPosition, 100));
  
      dispatch(setAnimationControlRoute(newPosition))
    };
  
    // Sürükleme işlemini durdur
    const handleMouseUp = () => {
      setIsDragging(false); // Sürükleme işlemini durdur
    };
  
    // Sürükleme sırasında konumu güncelle
    const handleMouseMove = (e) => {
      if (!isDragging) return; // Sürüklenmiyorsa çık
  
      const slider = sliderRef.current;
      const sliderRect = slider.getBoundingClientRect();
      const offsetX = e.clientX - sliderRect.left; // Fare pozisyonu - slider'ın sol kenarı
      let newPosition = (offsetX / sliderRect.width) * 100; // Yüzdelik konumu hesapla
  
      // Minimum değeri 1 olarak ayarla ve maksimum değeri 100 ile sınırla
      newPosition = Math.max(1, Math.min(newPosition, 100));
  
      dispatch(setAnimationControlRoute(newPosition))
    };
  
    // Sürükleme sırasında mouse hareketlerini dinlemek için event listener ekle
    useEffect(() => {
      if (isDragging) {
        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);
      } else {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
      }
  
      // Cleanup function to remove event listeners
      return () => {
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
      };
    }, [isDragging]); // isDragging değiştiğinde effect'i çalıştır
  



  return (
    <Container ref={sliderRef} onMouseDown={handleMouseDown} position={animationControlRoute}>
        <div className="dot">
        </div>
    </Container>
  )
}

export default LineRouteSliderInput